import styles from "./index.module.scss";

export interface CoverProps {
  src: string;
}
const Cover = ({ src }: CoverProps) => {
  if (!src) {
    return <div className={styles.cover} />;
  }
  return <img className={styles.cover} src={src} alt="" />;
};

export default Cover;
